<!-- 发票提取单据 -->
<template>
   <div>
      <el-form v-if="formShow" :inline="true" label-width="100px" :model="invoiceExtractData" class="demo-form-inline dis" size="mini">
         <el-row>
            <el-form-item label="货主名称">
               <label slot="label" :style="$common.labelStyle('货主名称')" v-html="'货主名称'"></label>
               <el-input clearable v-model="invoiceExtractData.coName" class="form_codition" @keyup.enter.native="openSearch('4414428383875072', 0, 'coName','coId,coName')">
                  <el-button @click="openSearch('4414428383875072', 0, 'coName','coId,coName')" slot="append" icon="el-icon-search"></el-button>
               </el-input>
            </el-form-item>
            <el-form-item label="业务单号">
               <label slot="label" :style="$common.labelStyle('业务单号')" v-html="'业务单号'"></label>
               <el-input clearable v-model="invoiceExtractData.businessId" class="form_codition"></el-input>
            </el-form-item>
            <el-form-item label="通用名称">
               <label slot="label" :style="$common.labelStyle('通用名称')" v-html="'通用名称'"></label>
               <el-input clearable v-model="invoiceExtractData.bgmName" class="form_codition"></el-input>
            </el-form-item>
            <el-form-item label="总金额">
               <label slot="label" :style="$common.labelStyle('总金额')" v-html="'总金额'"></label>
               <el-input clearable type="number" v-model="invoiceExtractData.totalMoney" class="form_codition"></el-input>
            </el-form-item>
            <el-form-item>
               <el-button size="mini" @click="getList()" type="primary">查询</el-button>
               <el-button size="mini" :disabled="returnObj.mainData.length==0" @click="sureDetail()" type="primary">确定选择</el-button>
            </el-form-item>
         </el-row>
      </el-form>
      <!-- 表格 -->
      <el-table ref="moviesTable" height="360" size="mini" style="width: 100%" :data="mainData" border stripe highlight-current-row :header-cell-style="getHeaderCellStyle" @row-dblclick="dblclick"
                @selection-change="mainSelectionChange">
         <el-table-column type="selection" width="50"></el-table-column>
         <el-table-column align="center" min-width="120" prop="businessId" label="业务单号" :show-overflow-tooltip="true"></el-table-column>
         <el-table-column align="center" min-width="120" prop="businessType" label="订单类型" :show-overflow-tooltip="true"></el-table-column>
         <el-table-column align="center" min-width="120" prop="opmName" label="业务员名称" :show-overflow-tooltip="true"></el-table-column>
         <el-table-column align="center" min-width="120" prop="coName" label="货主" :show-overflow-tooltip="true"></el-table-column>
         <el-table-column align="center" min-width="120" prop="salesName" label="供货商业务员" :show-overflow-tooltip="true"></el-table-column>
         <el-table-column align="center" min-width="120" prop="smName" label="购进单位名称" :show-overflow-tooltip="true"></el-table-column>
         <el-table-column align="center" min-width="120" prop="totalNumber" label="总数量" :show-overflow-tooltip="true"></el-table-column>
         <el-table-column align="center" min-width="120" prop="oldMoney" label="总金额" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
   </div>
</template>

<script>
export default {
   name: "feeRegistration",
   components: {},
   data() {
      return {
         opmId: "",
         ormId: "",
         mainData: [],
         multipleSelection: [], //数组内层
         returnObj: {//外层对象数据
            mainData: [],
         },
         seWidth: "",
         seTitle: "",
         DialogVisible: false,
         parentSearchData: {}
      };
   },

   props: {
      invoiceExtractData: {
         type: Object,
         require: true
      },
      formShow: {
         type: Boolean,
         require: true,
         default: false
      },

   },
   watch: {},
   computed: {},
   mounted() { },
   created() {
      // 处理组件需要的数据
      this.opmId = JSON.parse(sessionStorage.getItem("userInfo")).opmId
      this.getTableMainList()
   },
   methods: {
      getSeWidth(e) {
         // console.log(e);
         this.seWidth = e + "%";
      },
      getWidth(e) {
         // console.log(e);
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         // console.log(e);
         this.seTitle = e;
      },
      //检索带回数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            if (this.seType == 'smName') this.parentSearchData.smId = val.smId
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.$set(this.invoiceExtractData, item, val[item])
         })
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {

         this.DialogVisible = true
         this.seType = type
         this.seId = sId
         this.sField = sField
         this.parentSearchData[type] = this.invoiceExtractData[type]
      },

      //主单选择
      mainSelectionChange(val) {
         this.returnObj.mainData = JSON.parse(JSON.stringify(val))
      },
      dblclick(row) {
         var flag = false
         this.returnObj.mainData.forEach((item, index) => {
            if (item.businessId == row.businessId && !flag) {
               flag = true
               this.$refs.moviesTable.toggleRowSelection(row, false)
               this.returnObj.mainData.splice(index, 1)
            }
         })
         if (!flag) {
            this.$refs.moviesTable.toggleRowSelection(row, true)
            this.returnObj.mainData.push(row)
         }
      },
      //确认选择
      sureDetail() {
         this.returnObj.mainData.sort(function (a, b) {
            return b.createTime - a.createTime
         })
         var params=JSON.parse(JSON.stringify(this.returnObj))
         params.detailData=[]
         params.mainData.forEach(item=>{
            this.$set(item, 'isDetails', 0)
         })
         this.$emit("invoiceExtractMethods", params);
      },
      getList() {//查询
         this.getTableMainList()
      },
      // 获取主表格
      async getTableMainList() {
         let res = await this.$http.psdocumentsextractSmfr(this.invoiceExtractData)
         if (res && res.status == 200) {
            this.mainData = res.result; //默认第一条
         } else {
            this.$message({
               message: res.message,
               type: 'error'
            });
            this.$emit("invoiceExtractMethods", '')
            return false
         }
      },
      //   -----------------------------------------------------
      getHeaderCellStyle() {
         return "background: skybule; borderBottom: solid 1px #5a5e66;color: #3e5569";
      },
      getHeaderCellStyleD() {
         return "background: skybule;color: #3e5569";
      },

   },
};
</script>

<style scoped>
.el-pagination {
   padding: 20px 0px 5px;
}
</style>
